/**
 * Survey Design Tokens
 *
 * A restrained subset of the Blackbird brand, optimized for
 * survey completion rates and methodological neutrality.
 */

export const surveyTheme = {
  colors: {
    // Backgrounds
    background: '#FDFBF7',      // Warm ivory - distinctive but not distracting
    surface: '#FFFFFF',         // White - for choice buttons

    // Text
    textPrimary: '#1A1614',     // Near-black - questions, selected text
    textSecondary: '#4A443F',   // Dark gray - choice text
    textMuted: '#6E6761',       // Medium gray - progress, helper text

    // Interactive
    teal: '#3B6B6B',            // Primary accent - selection, progress
    tealLight: '#4A7C7C',       // Hover state

    // Borders
    borderLight: '#E5E2DE',     // Unselected choice borders
    borderMedium: '#D1CEC9',    // Subtle dividers
  },

  typography: {
    // Font stack with swap behavior
    fontFamily: "'Inter', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",

    // Sizes
    question: {
      fontSize: { base: '22px', md: '26px' },
      fontWeight: 600,
      lineHeight: 1.3,
    },
    choice: {
      fontSize: { base: '17px', md: '18px' },
      fontWeight: 450,
      lineHeight: 1.5,
    },
    progress: {
      fontSize: '13px',
      fontWeight: 500,
      letterSpacing: '0.02em',
    },
    body: {
      fontSize: { base: '17px', md: '18px' },
      fontWeight: 400,
      lineHeight: 1.6,
    },
  },

  spacing: {
    screenPadding: { base: '20px', md: '32px' },
    questionGap: { base: '32px', md: '40px' },
    choiceGap: '12px',
    buttonPadding: { base: '18px 20px', md: '20px 24px' },
  },

  radii: {
    button: '12px',
    progress: '4px',
  },

  transitions: {
    fast: '150ms ease',
    normal: '200ms ease',
    slow: '300ms ease',
  },

  shadows: {
    subtle: '0 1px 3px rgba(26, 22, 20, 0.08)',
    selected: '0 2px 8px rgba(59, 107, 107, 0.15)',
  },
};

export default surveyTheme;
